export default {
  buttons: {
    sign_in: 'Anmelden',
    sign_up: 'Registrieren',
    logout: 'Abmelden',
  },
  logout_confirm: {
    title: 'Abmelden?',
    description: 'Bist du sicher, dass du dich abmelden möchtest?',
    cancel: 'Abbrechen',
    confirm: 'Abmelden',
  },
};
